import React, { useEffect, useState } from "react";
import { getAllProducts } from "../apis/config";
import { Link, useNavigate } from "react-router-dom";

const ListViewer = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getAllProducts()
      .then((res) => {
        setProducts(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const newProducts = products
    .slice()
    .reverse()
    .filter((pro) =>
      pro.label.some((p) => p.toLowerCase() === "new")
    )
    .slice(0, 3);

  const trendProducts = products
    .slice()
    .reverse()
    .filter((pro) =>
      pro.label.some((p) => p.toLowerCase() === "trend")
    )
    .slice(0, 3);

  const bestProducts = products
    .slice()
    .reverse()
    .filter((pro) =>
      pro.label.some((p) => p.toLowerCase() === "best sale")
    )
    .slice(0, 3);

  const handleBuy = (id) => {
    navigate(`/products/${id}`);
  };

  return (
    <div className="py-5 px-3 md:px-20 flex justify-between flex-col md:flex-row">
      {/* NEW ARRIVALS */}
      <ListSection title="New Arrivals" loading={loading} products={newProducts} handleBuy={handleBuy} />

      {/* UPCOMING */}
      <ListSection title="Upcoming" loading={loading} products={trendProducts} handleBuy={handleBuy} />

      {/* BEST SELLER */}
      <ListSection title="Best Seller" loading={loading} products={bestProducts} handleBuy={handleBuy} />
    </div>
  );
};

export default ListViewer;
const ListSection = ({ title, loading, products, handleBuy }) => {
  return (
    <div>
      <h3 className="font-bold py-5">{title}</h3>
      <div className="flex flex-col gap-5">
        {loading
          ? Array(3)
              .fill(0)
              .map((_, i) => <ListSkeleton key={i} />)
          : products.map((data, index) => (
              <div
                key={index}
                className="flex border-gray-300 h-[120px] overflow-hidden border w-full md:w-[350px]"
              >
                <div className=" w-[180px] h-[120px]">
                 <img src={data.images[0]} alt="image" className=" w-full h-full object-cover object-center" />
                </div>

                <div className="p-3 flex flex-col gap-2 w-full">
                  <h3 className="font-bold text-[14px] hover:text-primary cursor-pointer">
                    <Link to={`/products/${data._id}`}>{data.name}</Link>
                  </h3>

                  <h4 className="text-[12px] text-red-600 font-bold">
                    ₹{data.salePrice}{" "}
                    <span className="line-through text-gray-700 font-normal text-[12px]">
                      ₹{data.price}
                    </span>
                  </h4>

                  <button
                    className="w-fit text-[12px] uppercase font-bold hover:text-primary hover:border-primary border-black border-b-2 hover:border-0 duration-150 ease-linear"
                    onClick={() => handleBuy(data._id)}
                  >
                    Buy Now
                  </button>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};
const ListSkeleton = () => {
  return (
    <div className="flex border-gray-300 h-[120px] overflow-hidden border w-full md:w-[350px] animate-pulse">
      {/* Image box */}
      <div className="w-[120px] h-[120px] bg-gray-300"></div>

      {/* Right text area */}
      <div className="p-5 flex flex-col gap-3 w-full">
        <div className="h-4 bg-gray-300 rounded w-3/4"></div>
        <div className="h-3 bg-gray-300 rounded w-1/2"></div>
        <div className="h-3 bg-gray-300 rounded w-1/3"></div>
        <div className="h-4 bg-gray-300 rounded w-16"></div>
      </div>
    </div>
  );
};


// import React, { useEffect, useState } from "react";
// import { getAllProducts } from "../apis/config";
// import { Link, useNavigate } from "react-router-dom";

// //   {
// //     title: "Fine-knit sweater",
// //     category: "category1",
// //     image: "assets/products/f-product-5.jpg",
// //     label: "sale",
// //     rate: 3,
// //     price: 50,
// //     sellPrice: 20,
// //   },
// //   {
// //     title: "Fine-knit sweater",
// //     category: "category1",
// //     image: "assets/products/f-product-6.jpg",
// //     label: "sale",
// //     rate: 3,
// //     price: 50,
// //     sellPrice: 20,
// //   },
// //   {
// //     title: "Fine-knit sweater",
// //     category: "category1",
// //     image: "assets/products/f-product-7.jpg",
// //     label: "sale",
// //     rate: 3,
// //     price: 50,
// //     sellPrice: 20,
// //   },
// // ];

// const ListViewer = () => {
//   const [products,setProducts] = useState([])
//   const navigate = useNavigate()
//   useEffect(()=>{
//     getAllProducts().then(res=>setProducts(res.data)).catch(err=>console.log(err))
//   },[])
//   const newProducts = products.reverse().filter(pro=>pro.label.some(p=>p.toLowerCase()==='new')).slice(0,3)
//   const trendProducts = products.reverse().filter(pro=>pro.label.some(p=>p.toLowerCase()==='trend')).slice(0,3)
//   const bestProducts = products.reverse().filter(pro=>pro.label.some(p=>p.toLowerCase()==='best sale')).slice(0,3)

//   const handleBuy = (id)=>{
//     navigate(`/products/${id}`)
//   }
//   return (
//     <div className=" py-5 px-3 md:px-20 flex justify-between  flex-col md:flex-row">
//       <div>
//         <h3 className="font-bold py-5">New Arrivals</h3>
//         <div className=" flex flex-col gap-5">
//           {newProducts.map((data, index) => (
//             <div key={index} className=" flex border-gray-300  h-[120px] overflow-hidden border-[1px] w-full md:w-[350px] ">
//               <div className=" w-[120px] h-[120px]">
//                 <img src={data.images[0]} alt="image" className=" w-full h-full object-cover object-center" />
//               </div>
//               <div className=" p-5 flex flex-col gap-2">
//                 <h3 className=" font-bold text-[14px] hover:text-primary cursor-pointer">
//                   <Link to={`/products/${data._id}`}>{data.name}</Link>
//                 </h3>
//                 <h4 className=" text-[12px] w-fit text-red-600 font-bold">
//                   {" "}
//                   &#8377; {data.salePrice}{" "}
//                   <span className=" line-through text-gray-700 font-normal text-[12px]">
//                     &#8377; {data.price}
//                   </span>
//                 </h4>
//                 <button className=" w-fit text-[12px] uppercase font-bold hover:text-primary hover:border-primary border-black border-b-2 hover:border-0 duration-150 ease-linear" onClick={()=>handleBuy(data._id)}>
//                   Buy Now
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div>
//         <h3 className="font-bold py-5">Upcoming</h3>
//         <div className=" flex flex-col gap-5">
//           {trendProducts.map((data, index) => (
//             <div className=" flex border-gray-300  h-[120px] overflow-hidden border-[1px] w-full md:w-[350px]">
//               <div className=" w-[120px] h-[120px]">
//                 <img src={data.images[0]} alt="image" className=" w-full h-full object-cover object-center" />
//               </div>
//               <div className=" p-2 flex flex-col gap-2">
//                 <h3 className=" font-bold text-[14px] hover:text-primary cursor-pointer">
//                   <Link to={`/products/${data._id}`}>{data.name}</Link>
//                 </h3>
//                 <h4 className=" text-[12px] font-boldw-fit text-red-600 font-bold">
//                   {" "}
//                   &#8377; {data.salePrice}{" "}
//                   <span className=" line-through text-gray-700 font-normal text-[12px]">
//                     &#8377; {data.price}
//                   </span>
//                 </h4>
//                 <button className=" w-fit text-[12px] uppercase font-bold hover:text-primary hover:border-primary border-black border-b-2 hover:border-0 duration-150 ease-linear" onClick={()=>handleBuy(data._id)}>
//                   Buy Now
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div>
//         <h3 className="font-bold py-5">Best Seller</h3>
//         <div className=" flex flex-col gap-5">
//           {bestProducts.map((data, index) => (
//             <div className=" flex border-gray-300  h-[120px] overflow-hidden border-[1px] w-full md:w-[350px]">
//               <div className=" w-[120px] h-[120px]">
//                 <img src={data.images[0]} alt="image" className=" w-full h-full object-cover object-center" />
//               </div>
//               <div className=" p-5 flex flex-col gap-2">
//                 <h3 className=" font-bold text-[14px] hover:text-primary cursor-pointer">
//                   <Link to={`/products/${data._id}`}>{data.name}</Link>
//                 </h3>
//                 <h4 className=" text-[12px] font-boldw-fit text-red-600 font-bold">
//                   {" "}
//                   &#8377; {data.salePrice}{" "}
//                   <span className=" line-through text-gray-700 font-normal text-[12px]">
//                     &#8377; {data.price}
//                   </span>
//                 </h4>
//                 <button className=" w-fit text-[12px] uppercase font-bold hover:text-primary hover:border-primary border-black border-b-2 hover:border-0 duration-150 ease-linear" onClick={()=>handleBuy(data._id)}>
//                   Buy Now
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ListViewer;
